class EventBus {
  constructor() {
    this.bus = document.createElement("div");
    this.listeners = {};
  }

  addListener(event, listener) {
    if (!(event in this.listeners)) {
      this.listeners[event] = [];
    }

    this.bus.addEventListener(event, listener);
    this.listeners[event].push(listener);
  }

  removeListener(event, listener) {
    if (!(event in this.listeners)) {
      return;
    }

    this.bus.removeEventListener(event, listener);

    let stack = this.listeners[event];
    for (let i = 0, l = stack.length; i < l; i++) {
      if (stack[i] === listener) {
        stack.splice(i, 1);
        return;
      }
    }
  }

  dispatch(event, channel = "*", params = {}) {
    if (!(event in this.listeners)) {
      console.warn(`Event [${event}] does not have any active subscribers`);
      return;
    }

    this.bus.dispatchEvent(
      new CustomEvent(event, {
        detail: {
          channel,
          params
        }
      })
    );
  }
}

const instance = new EventBus();

export default Object.freeze(instance);
